import { href } from '../app/useHashRoute.js';
import { Disclaimer } from '../components/Disclaimer.js';

export function OpeningScreen() {
  return (
    <div className="opening">
      <div className="opening__ticker" aria-hidden="true">
        <span>
          BREAKING ● ALL LEADERS FICTIONAL ● ALL COUNTRIES FICTIONAL ● NO ESCALATORS WERE HARMED ●
          BREAKING ● ALL LEADERS FICTIONAL ● ALL COUNTRIES FICTIONAL ● NO ESCALATORS WERE HARMED ●
        </span>
      </div>
      <div className="page stack opening__content">
        <div className="opening__slate">
          <p className="opening__kicker">Special broadcast</p>
          <h1 className="opening__title">
            State <span className="opening__of">of</span> Emergency
          </h1>
          <p className="opening__sub">
            Eight players. Two teams. One spectacularly unpopular head of state.
          </p>
        </div>
        <Disclaimer />
        <div className="cluster opening__actions">
          <a className="btn btn--primary" href={href('menu')}>
            I understand, enter
          </a>
        </div>
        <p className="opening__legal muted-on-dark">
          By entering you agree to the <a href={href('terms')}>terms of use</a>. The{' '}
          <a href={href('privacy')}>privacy notice</a> explains the little we store.
        </p>
      </div>
    </div>
  );
}
